/**
 * Real `@itk-wasm/dicom` (official, pre-built WASM, v7.6.4). Lazy pipeline
 * fetch, see `downsampleClient.ts`'s header for the shared notes -- this
 * package's pipeline is the largest of the four (~29 MB), so the "only on
 * click" rule matters most here.
 *
 * Confirmed executing real native DICOM-parsing code (not a stub) by driving
 * the Node variant against a deliberately invalid file and observing a real
 * pipeline-level parse exception, not a generic JS error (see the fork
 * report for this pass) -- a full synthetic multi-file DICOM series was out
 * of scope for this pass's time budget, so this path is API-shape-verified
 * and parse-exception-verified, not success-path-verified end-to-end.
 */
import { readImageDicomFileSeries } from "@itk-wasm/dicom";

import type { NiftiVolume } from "@/lib/nifti";
import { itkImageToNiftiVolume } from "./itkImage";

export interface DicomImportResult {
  volume: NiftiVolume;
  sortedFilenames: string[];
}

export async function importDicomSeries(files: File[]): Promise<DicomImportResult> {
  const { outputImage, sortedFilenames } = await readImageDicomFileSeries({
    inputImages: files,
    singleSortedSeries: true,
  });
  return {
    volume: itkImageToNiftiVolume(outputImage),
    sortedFilenames: Object.values(sortedFilenames ?? {}) as string[],
  };
}
